import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Syncs the global header search with the active list page toolbar search.
 */
@Injectable({ providedIn: 'root' })
export class ListPageSearchService {
  private readonly term$ = new BehaviorSubject('');
  private activeConsumer = false;

  readonly changes$ = this.term$.asObservable();

  get term(): string {
    return this.term$.value;
  }

  /** Call from list pages in ngOnInit / ngOnDestroy. */
  setConsumerActive(active: boolean): void {
    this.activeConsumer = active;
    if (!active) {
      this.term$.next('');
    }
  }

  setTerm(term: string): void {
    const next = term ?? '';
    if (this.term$.value === next) {
      return;
    }
    this.term$.next(next);
  }
}
